const descriptions = {
  D: [
    "Dominance (D) - Bạn là người quyết đoán, thích lãnh đạo và luôn muốn đạt được mục tiêu nhanh chóng.",
    "Dominance (D) - Bạn không quá chú trọng đến quyền lực và lãnh đạo, thích làm việc độc lập.",
  ],
  I: [
    "Influence (I) - Bạn là người năng động, giao tiếp tốt và có khả năng thuyết phục người khác.",
    "Influence (I) - Bạn có thể ít chú trọng đến việc tạo ảnh hưởng hoặc giao tiếp với người khác.",
  ],
  S: [
    "Steadiness (S) - Bạn là người kiên nhẫn, ổn định và có xu hướng hỗ trợ người khác một cách kiên định.",
    "Steadiness (S) - Bạn ít kiên nhẫn hơn và thích sự thay đổi hơn là sự ổn định.",
  ],
  C: [
    "Conscientiousness (C) - Bạn rất chú ý đến chi tiết, có tính tổ chức và luôn hoàn thành công việc với chất lượng cao.",
    "Conscientiousness (C) - Bạn ít chú trọng đến chi tiết và đôi khi thích sự linh hoạt hơn là sự chính xác tuyệt đối.",
  ],
};
export default descriptions;
